<template>
  <focus-trap :active="navActive">
    <!-- NAV HEADER -->
    <nav
      class="bleach-nav"
      :style="{
        height: `${viewportHeight}px`
      }"
      tabindex="-1"
    >
      <div class="bleach-nav__header" @click="handleNavSelect">
        <!-- <div class="bleach-nav__header-background-holder">
        </div> -->
        <div class="bleach-nav__header-content flex--row-center-center">
          <div class="bleach-nav__header-items flex--row-start-center">
            <!-- Nav trigger -->
            <template v-if="GET_IS_BELOW_BREAKPOINT('lg')">
              <div class="bleach-nav__item-holder">
                <MenuControl
                  :active="navActiveElement === 'menu'"
                  @click="handleMenuToggle"
                  root
                />
              </div>
              <div
                v-if="GET_IS_BELOW_BREAKPOINT('md')"
                class="bleach-nav__item-holder"
              >
                <AccountControl :active="navActiveElement === 'login'" root />
              </div>
            </template>
            <div
              v-if="GET_IS_ABOVE_BREAKPOINT('lg')"
              class="bleach-nav__item-holder"
            >
              <StoreControl class="bleach-nav__store-control" root />
            </div>
          </div>
          <div
            class="bleach-nav__header-items bleach-nav__header-items--logo flex--col-center-center"
          >
            <LinkTag
              @click.native="handleNavSelect"
              class="bleach-nav__logo-link"
              :link="`/`"
            >
              <!-- <template>
                <div class="bleach-nav__logo-sizer flex--col-center-center">
                  <BleachLogo
                    class="bleach-nav__logo"
                    :style="{ fill: getUiColour }"
                  />
                </div>
              </template> -->
            </LinkTag>
          </div>
          <div class="bleach-nav__header-items flex--row-end-center">
            <div
              v-if="GET_IS_ABOVE_BREAKPOINT('md')"
              class="bleach-nav__item-holder bleach-nav__item-holder--end"
            >
              <AccountControl :active="navActiveElement === 'login'" root />
            </div>
            <!-- Search trigger -->
            <div class="bleach-nav__item-holder bleach-nav__item-holder--end">
              <SearchControl
                :active="navActiveElement === 'search'"
                @click="handleSearchToggle"
                root
              />
            </div>
            <!-- Cart -->
            <div class="bleach-nav__item-holder bleach-nav__item-holder--end">
              <CartControl @click="handleCartTrigger" root />
            </div>
          </div>
        </div>
        <div class="bleach-nav__load-spinner-holder">
          <LoadSpinner />
        </div>
      </div>
      <!-- MENU LAYER -->
      <div class="bleach-nav__menu">
        <NavMenu
          :active="navActiveElement === 'menu'"
          @activated="setMenuActive"
          @select="handleNavSelect"
          ref="navMenu"
          root
        />
      </div>

      <!-- SEARCH LAYER -->
      <div class="bleach-nav__search">
        <NavSearch
          :active="navActiveElement === 'search'"
          @activated="setSearchActive"
          @select="handleNavSelect"
          ref="navSearch"
        />
      </div>

      <!-- CART LAYER -->
      <div class="bleach-nav__cart">
        <Cart :active="navActiveElement === 'cart'" ref="cart" />
      </div>

      <div class="bleach-nav__cart-alert">
        <CartAlert />
      </div>

      <!-- Interstitial -->
      <!-- <div class="bleach-nav__header-interstitial">
        <Interstitial />
      </div> -->
    </nav>
  </focus-trap>
</template>

<script>
import MenuControl from "./../../components/Navigation/MenuControl.vue"
import StoreControl from "./../../components/Navigation/StoreControl.vue"
import SearchControl from "./../../components/Navigation/SearchControl.vue"
import CartControl from "./../../components/Navigation/CartControl.vue"
import AccountControl from "./../../components/Navigation/AccountControl.vue"
import NavMenu from "./../NavigationMenu/NavigationMenu.vue"
import NavSearch from "./../NavigationSearch/NavigationSearch.vue"
import Cart from "./../Cart/Cart.vue"

import CartAlert from "./../../components/CartAlert.vue"
import LoadSpinner from "./LoadSpinner.vue"

import GTMAPI from "@/integration/GTMAPI"

import { mapState, mapActions, mapMutations, mapGetters } from "vuex"

import "./NavigationStyles.scss"

export default {
  props: {},

  components: {
    MenuControl,
    StoreControl,
    AccountControl,
    CartControl,
    SearchControl,
    NavMenu,
    NavSearch,
    CartAlert,
    Cart,
    LoadSpinner
    // Interstitial
  },

  created() {},

  methods: {
    ...mapActions("cart", ["OPEN_CART", "CLOSE_CART"]),
    ...mapActions("ui", ["UPDATE_NAV_APPEARANCE"]),
    ...mapMutations("ui", ["SET_NAV_ACTIVE_ELEMENT"]),

    handleMenuToggle() {
      this.setMenuActive(this.navActiveElement !== "menu")
    },
    handleSearchToggle() {
      this.setSearchActive(this.navActiveElement !== "search")
    },
    handleCartTrigger() {
      if (
        this.$router.currentRoute.path !== "/cart" &&
        this.navActiveElement !== "cart"
      ) {
        this.OPEN_CART()
      }
    },
    handleNavSelect() {
      if (this.navActiveElement !== null) {
        this.SET_NAV_ACTIVE_ELEMENT(null)
      }
    },

    setMenuActive(val) {
      if (this.navActiveElement == null && val) {
        this.SET_NAV_ACTIVE_ELEMENT("menu")
      } else {
        this.SET_NAV_ACTIVE_ELEMENT(null)
      }
    },

    setSearchActive(val) {
      if (val) {
        this.SET_NAV_ACTIVE_ELEMENT("search")
        GTMAPI.trackEvent("search_result.enabled")
      } else {
        this.SET_NAV_ACTIVE_ELEMENT(null)
      }
    }
  },

  computed: {
    ...mapState("ui", ["navBaseColour", "navUiColour", "navActiveElement"]),
    ...mapState("scroll", ["scrollLockOffset", "scrollPos", "viewportHeight"]),
    ...mapState("breakpoints", ["currentWidth"]),
    ...mapGetters("breakpoints", [
      "GET_IS_ABOVE_BREAKPOINT",
      "GET_IS_BELOW_BREAKPOINT"
    ]),
    ...mapGetters("content", ["GET_SITE_CONFIG"]),

    navActive() {
      return ["search", "menu"].includes(this.navActiveElement)
    }
  },

  watch: {
    $route(to, from) {
      // Added the null check because it will trigger on
      // page load, which would unset the default value from created()
      if (to !== from && from.name != null) {
        // console.log(
        //   "NAV watcher - $route change",
        //   "from:",
        //   from,
        //   "     : to:",
        //   to
        // )
        // this.UPDATE_NAV_APPEARANCE()
        this.handleNavSelect()
      }
    },

    // scrollPos(newVal) {
    //   if (!this.autoScroll) this.onScroll(newVal)
    // },

    currentWidth() {
      this.setMenuActive(false)
    }
  }
}
</script>

<style lang="scss">
// @import "./NavigationStyles.scss";
</style>
